jQuery(document).ready(function ($) {
  //Category filter
  $(".c-category-filter__nav-title").click(function () {
    $(".c-category-filter__child-menu").toggleClass("open").slideToggle(200);
    $(this).toggleClass("active");
    $(".dd-arrow").toggleClass("open");
  });
});
